<template>
  <b-overlay
    :show="loading"
    class="bg-white "
  >
    <div class="row">
      <div
        class="col-12 mt-3"
      >
        ¿Estás seguro de que quieres aprobar {{ batches.length }} lotes?
      </div>
      <vs-divider></vs-divider>
      <b-col
        cols="12"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          v-on:click="onApprove"
          data-cy="cancel-batch"
        >
          Si, Estoy seguro!
        </b-button>
      </b-col>
    </div>

  </b-overlay>
</template>
<script>

import MasivasMixin from '@/febos/global/_vue/mixins/MasivasMixin';
import { LLAMADA_MASIVA_ADUANA_APROBAR_LOTE_BASE } from '@/febos/servicios/api/aduanas/constantes';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  mixins: [MasivasMixin],
  data() {
    return {
      loading: false
    };
  },
  props: {
    batches: {
      type: Array,
      required: true
    }
  },
  methods: {
    async onApprove() {
      const payload = {
        ...LLAMADA_MASIVA_ADUANA_APROBAR_LOTE_BASE,
        ...{
          comunes: {
            ...LLAMADA_MASIVA_ADUANA_APROBAR_LOTE_BASE.comunes,
            accion: 'aprobar'
          },
          payload: this.batches.map(
            (batch) => ({
              lote_id: batch.loteId
            })
          )
        }
      };
      this.loading = true;
      try {
        await this.sendMasiveProcess(payload);
        this.$vs.notify({
          title: 'Genial!',
          text: `Se ha solicitado la aprobación de ${this.batches.length} lotes,
          te enviaremos un correo con los detalles cuando esta termine.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
        this.$emit('approve');
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.loading = false;
  }
};
</script>
